import { BiteLogWorldpayEvent } from './bite_log_worldpay_event.js';

export function name(event: BiteLogWorldpayEvent): string {
  switch (event) {
    case BiteLogWorldpayEvent.TerminalDisconnected:
      return 'terminal-disconnected';
    case BiteLogWorldpayEvent.UpdateIdleTextError:
      return 'update-idle-text-error';
    case BiteLogWorldpayEvent.TerminalRebootRequestSuccess:
      return 'terminal-reboot-request-success';
    case BiteLogWorldpayEvent.TerminalRebootRequestError:
      return 'terminal-reboot-request-error';
    case BiteLogWorldpayEvent.TerminalIdleTextRequestSuccess:
      return 'terminal-idle-text-request-success';
    case BiteLogWorldpayEvent.TerminalIdleTextRequestError:
      return 'terminal-idle-text-request-error';
  }
}
